import Vue from 'vue';
import Vuex from 'vuex';
import augmentations from './modules/augmentations';
import actions from './modules/actions';
import experiences from './modules/experiences';
import app from './modules/app';
import createPersistedState from 'vuex-persistedstate';

export function getVuexPeristence (key, defaultValue) {
    var vuexPersitence = JSON.parse(window.localStorage.getItem('vuex'));
    return vuexPersitence && !!Object.keys(vuexPersitence).includes(key) ? vuexPersitence[key] : defaultValue;
}

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
    modules: {
        augmentations,
        actions,
        experiences,
        app
    },
    plugins: [createPersistedState({
        reducer: (state) => ({
            'app.menuDrawable': state.app.menuDrawable,
            'experiences.selectSortDescription': state.experiences.selectSortDescription,
            'augmentations.selectSortDescription': state.augmentations.selectSortDescription,
            'augmentations.orderSort': state.augmentations.orderSort
        })
    })],
    strict: debug
});

export default store;
